import { SectionTitleDivider } from './SectionTitleDivider';
import styles from './SectionTitle.module.css';

type SectionTitleProps = {
  title: string;
};

export const SectionTitle = ({ title }: SectionTitleProps) => {
  return (
    <div className={styles.sectionTitleLayout}>
      <SectionTitleDivider side='left' />
      <h2 className={styles.title}>{title}</h2>
      <SectionTitleDivider side='right' />
    </div>
  );
};
